export default "__VITE_ASSET__ff36f178__"